/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';
import { FileUploaderDropContainer, Button, FileUploaderItem } from '@carbon/react';

export const StyledFileUploaderDropContainer = styled(FileUploaderDropContainer)`
  width: 100%;
  min-height: 120px;
  max-width: 100%;
  margin-bottom: var(--spacing-medium);
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export const Container = styled.div`
  background-color: var(--cm-color-white-base);
  padding: var(--spacing-large);
  width: 100%;
  display: grid;
  grid-template-columns: min-content 50%;
`;

export const Icon = styled.div`
  margin-right: 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
`;

export const Title = styled.div`
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: var(--cm-color-black-primary-text);
  margin-bottom: 8px;
`;

export const Description = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--cm-color-black-primary-text);
  margin-bottom: 24px;
  letter-spacing: 0.16px;
`;

export const StyledFileUploaderItem = styled(FileUploaderItem)`
  background-color: var(--cds-background, #f4f4f4);
  border-radius: 0;
  border: none;
  width: 100%;
  max-width: 100%;
`;

export const FileListContainer = styled.div`
  width: 100%;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 24px;
`;

export const LoadingContainer = styled.div`
  margin-top: 24px;
  width: 100%;
`;
